import React from 'react';
import { Card } from '../ui/Card';
import { Button } from '../ui/Button';
import { DjayAvatar } from '../../mascot';
import { Chrome, RefreshCw } from 'lucide-react';
/**
 * UnsupportedBrowserScreen — Friendly Djay-styled fallback for browsers that
 * are too old to run the app (missing modern Web APIs like structuredClone,
 * globalThis, native async/await, etc.).
 *
 * Shown when boot detects a ReferenceError on a known modern global, or when
 * the explicit capability probe flags missing features.
 */
export function UnsupportedBrowserScreen({
  missingFeature
}: {
  missingFeature?: string;
}) {
  return <div className="min-h-screen w-full flex items-start sm:items-center justify-center px-4 py-8 bg-gradient-to-br from-orange-50 via-amber-50 to-yellow-50" data-id="element-2329">
      <Card className="max-w-lg w-full p-8 sm:p-10 text-center bg-white/90 backdrop-blur border-2 border-orange-100 shadow-xl rounded-[2rem] relative overflow-hidden" data-id="element-2330">
        <div className="absolute top-0 right-0 w-48 h-48 bg-orange-100/40 rounded-full blur-3xl -translate-y-1/2 translate-x-1/4 pointer-events-none" data-id="element-2331" />
        <div className="absolute bottom-0 left-0 w-40 h-40 bg-amber-100/40 rounded-full blur-3xl translate-y-1/2 -translate-x-1/4 pointer-events-none" data-id="element-2332" />

        <div className="relative z-10 flex flex-col items-center" data-id="element-2333">
          <div className="mb-5" data-id="element-2334">
            <DjayAvatar size="lg" emotion="sad" variant="default" animate data-id="element-2335" />
          </div>

          <h1 className="text-2xl sm:text-3xl font-black text-slate-800 mb-3 tracking-tight" data-id="element-2336">
            Hoi! Je browser is een beetje oud
          </h1>

          <p className="text-slate-600 mb-2 text-base leading-relaxed font-medium max-w-md" data-id="element-2337">
            Meester Djay werkt het beste in een{' '}
            <span className="font-bold text-slate-800" data-id="element-2338">moderne browser</span>.
            Probeer een nieuwere versie van Chrome, Firefox, Safari of Edge.
          </p>

          <p className="text-slate-500 mb-6 text-sm leading-relaxed max-w-md" data-id="element-2339">
            Vraag een ouder of leerkracht om je te helpen met updaten — dan
            kunnen we samen verder oefenen! 🚀
          </p>

          <div className="w-full bg-orange-50/80 border border-orange-100 rounded-2xl p-4 mb-6 text-left" data-id="element-2340">
            <div className="flex items-start gap-3" data-id="element-2341">
              <Chrome className="w-5 h-5 text-orange-500 flex-shrink-0 mt-0.5" data-id="element-2342" />
              <div data-id="element-2343">
                <p className="text-sm font-semibold text-slate-700 mb-1" data-id="element-2344">
                  Aanbevolen browsers
                </p>
                <p className="text-xs text-slate-600 leading-relaxed" data-id="element-2345">
                  Chrome 98+, Firefox 94+, Safari 15.4+, Edge 98+ (vanaf 2022)
                </p>
              </div>
            </div>
          </div>

          <Button onClick={() => window.location.reload()} variant="primary" size="lg" className="shadow-lg rounded-2xl hover:shadow-xl transition-shadow w-full sm:w-auto" data-id="element-2346">
            <RefreshCw className="w-5 h-5 mr-2" data-id="element-2347" />
            Probeer opnieuw
          </Button>

          {missingFeature && <p className="mt-4 text-[11px] font-mono text-slate-400 select-all" data-id="element-2348">
              Ontbrekende functie: {missingFeature}
            </p>}
        </div>
      </Card>
    </div>;
}